<div class="content-login">
  <div class="login-form">
    <div class="mb-5 special">
      <p class="text-medium-description text-secondary">
        <span class="text-bold">¡Bienvenido!</span> <br />
        Accediste al mundo Digital de <br />
        Seguros SURA en donde el <br />
        proceso de tu siniestro será <br />
        completamente en línea. <br />
      </p>
    </div>
    <div class="mb-5 pt-2">
      <form action="" #loginForm="ngForm" (ngSubmit)="onSubmit(loginForm)">
        <div>
          <input
            ngModel
            #email="ngModel"
            type="text"
            class="form-control"
            placeholder="Correo electrónico"
            (ngModelChange)="reset()"
            name="email"
            required
            pattern="([a-z0-9._%+-]|[A-Z0-9._%+-])+@([a-z0-9._%+-]|[A-Z0-9._%+-])+\.([a-z]|[A-Z]){2,4}$"
          />
          <small
            *ngIf="!email.valid && email.touched && email.value == ''"
            class="text-danger ml-2"
          >
            Campo obligatorio *</small
          >
          <small
            *ngIf="!email.valid && email.touched && email.value != ''"
            class="text-danger ml-2"
          >
            Correo no válido</small
          >
        </div>
        <div>
          <div class="input-icon">
            <i
              *ngIf="!show"
              class="fas fa-eye-slash lock"
              (click)="switchPass()"
            ></i>
            <i *ngIf="show" class="fas fa-eye lock" (click)="switchPass()"></i>
            <input
              ngModel
              type="password"
              [type]="show ? 'text' : 'password'"
              class="form-control"
              (ngModelChange)="reset()"
              placeholder="Contraseña"
              #password="ngModel"
              required
              name="password"
            />
          </div>
          <small
            *ngIf="!password.valid && password.touched"
            class="ml-2 text-danger"
          >
            Campo obligatorio *</small
          >
        </div>
        <div *ngIf="errorMessage">
          <small class="text-danger ml-2"> {{ errorMessage }}</small>
        </div>
        <div *ngIf="mensajeEmailVerificado != ''">
          <small class="text-success ml-2"> {{ mensajeEmailVerificado }}</small>
        </div>

        <div class="button-top mt-3">
          <a [routerLink]="'/recover'" class="mt-2"
            >¿Problemas al iniciar sesión?</a
          >
          <button
            class="btn btn-primary mt-1"
            type="submit"
            [disabled]="!loginForm.valid"
          >
            Iniciar sesión
          </button>
        </div>
      </form>
    </div>
    <div class="text-center mb-3 mt-5">
      <p class="text-body">¿Aún no tienes cuenta de usuario?</p>
    </div>
    <div class="text-center">
      <app-button
        [text]="'NUEVO USUARIO'"
        [class]="'btn-outline-secondary'"
        [routerLink]="'/register'"
      ></app-button>
    </div>
  </div>
</div>

<!-- 
<ngx-smart-modal
  #myModal
  identifier="myModal"
  [customClass]="'nsm-centered'"
  class="text-center"
>
  <div style="padding: 50px" class="text-medium">
    <p>
      Lo sentimos, puede continuar el <br />
      trámite visitando la siguiente liga <br />
      <span class="text-secondary">www.suramexico.com</span>
    </p>
  </div>
</ngx-smart-modal>
<button (click)="llamar1()">Respuesta 1</button>
<ngx-smart-modal
  #myModal2
  identifier="myModal2"
  class="text-center"
  [customClass]="'nsm-centered'"
>
  <div style="padding: 50px" class="text-medium">
    <p>
      Verifique su información. <br />
      Puede actualizar su información <br />
      personal enviando un correo a <br />
      <span class="text-secondary">correo@sura.com.mx</span> o llamando <br />
      al 0800 SURA.
    </p>
  </div>
</ngx-smart-modal>
<button (click)="llamar2()">Respuesta 2</button>

<ngx-smart-modal
  #myModal3
  identifier="myModal3"
  class="text-center"
  [customClass]="'nsm-centered'"
>
  <div style="padding: 50px" class="text-medium">
    <p>
      Su cuenta ha sido <br />
      creada exitosamente, <br />
      ahora puede iniciar <br />
      sesión
    </p>
    <div class="mt-3">
      <app-button
        [text]="'Iniciar sesión'"
        [class]="'btn-primary'"
      ></app-button>
    </div>
  </div>
</ngx-smart-modal>
<button (click)="llamar3()">Respuesta 3</button> -->
